import { render, staticRenderFns } from "./printset.vue?vue&type=template&id=8f97f07a&scoped=true&"
import script from "./printset.vue?vue&type=script&lang=js&"
export * from "./printset.vue?vue&type=script&lang=js&"
import style0 from "./printset.vue?vue&type=style&index=0&id=8f97f07a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f97f07a",
  null
  
)

export default component.exports